import { getEntityColor } from '@/components/entity-colors';
import LoadingSpinner from '@/components/spinner';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { entityFieldsQueryOptions } from '@/queries/entityFieldsQueryOptions';
import { moduleDefinitionsQueryOptions } from '@/queries/moduleDefinitionsQueryOptions';
import { Separator } from '@radix-ui/react-separator';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router'
import Importer, { type SheetColumnDefinition } from 'hello-csv/react';
import 'hello-csv/react/index.css';

export const Route = createFileRoute(
  '/_app/$module_id/$entity_type_id/imports/',
)({
  component: RouteComponent,
  loader: async ({ context: { queryClient }, params }) => {
    await queryClient.ensureQueryData(entityFieldsQueryOptions(params.entity_type_id));
    await queryClient.ensureQueryData(moduleDefinitionsQueryOptions);
  }
})

function RouteComponent() {
  const { module_id, entity_type_id } = Route.useParams();


  const modulesQuery = useQuery(moduleDefinitionsQueryOptions);
  const modules = modulesQuery.data;
  const moduleDefinition = modules?.find(m => m.id === module_id);
  const currentEntityDefinition = moduleDefinition?.entityDefinitions?.find(e => e.id === entity_type_id);
  const color = getEntityColor(entity_type_id);

  let { data: fields, isLoading } = useQuery(entityFieldsQueryOptions(entity_type_id));

  if (!fields) {
    fields = [];
  }

  const columns: SheetColumnDefinition[] = fields.map(f => {


    var col: SheetColumnDefinition;



    if (f.viewItemType === 'currency-box' || f.viewItemType === 'number-box') {
      col = {
        type: 'number',
        id: f.name,
        label: f.name,
        validators: [

        ]
      } as SheetColumnDefinition;


    } else {
      col = {
        type: 'string',
        id: f.name,
        label: f.name,
        validators: [

        ]
      } as SheetColumnDefinition;
    }

    if (f.required) {
      col.validators?.push({
        validate: 'required',
        error: `${f.name} is required`
      });
    }


    return col;
  });


  return (
    <>
      <header
        className={`sticky top-0 flex shrink-0 items-center gap-2 p-2 bg-white border-b-4 border-l-gray-200 border-r-gray-200 border-t-gray-200 border-t-2`}
        style={{
          borderBottomColor: color?.primaryColor
        }}
      >
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mr-2 h-4" />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem className="hidden md:block">
              <BreadcrumbLink asChild>
                <Link to='/$module_id' params={{ module_id }} search={{
                  sort: [],
                  groupKeys: [],
                  rowGroupCols: [],
                  valueCols: []
                }}>
                  {moduleDefinition?.name}
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="hidden md:block" />
            <BreadcrumbItem className="hidden md:block">
              <BreadcrumbLink asChild>
                <Link to='/$module_id/$entity_type_id/segments/$segment_id' params={{ module_id, entity_type_id, segment_id: 'all' }} search={{
                  sortModel: [],
                  groupKeys: [],
                  rowGroupCols: [],
                  valueCols: []
                }}>
                  {currentEntityDefinition?.name}
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="hidden md:block" />
            <BreadcrumbItem>
              <BreadcrumbPage>
                Import
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <div className="flex items-center gap-2 ml-auto mr-5">

        </div>
      </header>

      <div className="h-full w-full " style={{ backgroundColor: color?.backgroundColor }}>

        {isLoading && <LoadingSpinner size='medium' />}

        {!isLoading && <Importer

          sheets={[
            {
              id: currentEntityDefinition?.id as string,
              label: currentEntityDefinition?.name as string,
              columns: columns
            },

          ]}
          onComplete={async (state, onProgress) => {
            console.log(state);
            // Optionally, call onProgress(100) if you want to indicate completion
            onProgress(100);
            return;
          }}
          persistenceConfig={{ enabled: true }}
        />}
      </div>
    </>
  );
}
